import React from "react";
import { Accordion, Card, Button } from "react-bootstrap";
import styled from "styled-components";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const AccordionList = ({ array }) => {
	return (
		<Wrapper>
			{array.map((item, index) => {
				return (
					<Card key={index}>
						<Card.Header className='header'>
							<Accordion.Toggle as={Button} variant='link' eventKey={item.key}>
								{item.header}
								<span style={{ float: "right" }}>
									<FaChevronDown />
								</span>
							</Accordion.Toggle>
						</Card.Header>
						<Accordion.Collapse eventKey={item.key}>
							<Card.Body>{item.body}</Card.Body>
						</Accordion.Collapse>
					</Card>
				);
			})}
		</Wrapper>
	);
};

export default AccordionList;

const Wrapper = styled(Accordion)`
	.header {
		background: transparent !important;
		border-top: 1px solid #d0d0d0 !important;
		padding: 0 !important;

		button {
			width: 100%;
			text-decoration: none;

			.i {
				transform: rotate(0deg);
				transition: all 0.5s;
			}
			i.active {
				transform: rotate(180deg);
			}
		}
	}
	.card-body,
	.card-body p {
		padding: 15px 30px;
		font-size: 14px;
		text-align: left;
		color: #8e8e8e;
		li {
			margin-left: 20px;
			margin-top: 5px;
			margin-bottom: 5px;
		}
	}
	.btn {
		color: #fff;
		display: block;
		text-align: left;
		background: #fff;
		color: #080e14;
		font-size: 14px;
		padding: 13px 30px;
		border-radius: 0;
		text-decoration: none;

		&:hover {
			text-decoration: none;
			font-weight: bold;
		}
	}
`;
